<template>
  <section
    id="chat-follow"
    ref="chatFollow"
  >
    <b-breadcrumb
      :items="breadcrumb"
    />

    <b-row>
      <b-col cols="12">
        <b-card-actions
          ref="filters"
          title="Filtros"
          class="form-filters"
          :action-close="false"
          :action-refresh="false"
          :action-collapse="true"
          @refresh="refreshStop('cardAction')"
        >
          <div
            v-if="isLoading"
            class="text-center table-spinner"
          >
            <b-spinner label="Loading..." />
            <strong>Carregando...</strong>
          </div>
          <div v-if="!isLoading">
            <b-row v-if="chatId">
              <b-col cols="12">
                <p>Exibindo somente o chat de número {{ chatId }}, proveniente da notificação</p>

                <b-button
                  id="btn-processar"
                  variant="primary"
                  @click="openDefaultChatFollow"
                >
                  Exibir filtros
                </b-button>
              </b-col>
            </b-row>

            <b-row v-if="!chatId">
              <b-col cols="5">
                <b-form-group
                  label="Arquivo CSV (exportado do SalesIQ)"
                  label-for="name"
                >
                  <small>Selecione um da lista</small>
                  <b-form-select
                    v-model="selectedFile"
                    :options="files"
                    @change="file = null"
                  />

                  <!--                  <small>ou envie um do seu computador</small>-->
                  <!--                  <b-form-file-->
                  <!--                    id="file"-->
                  <!--                    ref="file"-->
                  <!--                    v-model="file"-->
                  <!--                    @change="selectedFile = ''"-->
                  <!--                  />-->
                </b-form-group>

                <b-form-group
                  label="ID do Usuário"
                >
                  <b-form-input
                    v-model="userId"
                  />
                </b-form-group>
              </b-col>

              <b-col
                cols="7"
                class="form-buttons text-right d-flex justify-content-end flex-wrap align-content-end"
              >
                <b-form-group
                  label=""
                  label-for="btn-processar"
                  style="margin-top: 20px"
                >
                  <b-button
                    id="btn-processar"
                    :disabled="isLoading"
                    variant="primary"
                    @click="getUsers"
                  >
                    <b-spinner
                      v-if="isLoading"
                      small
                    />
                    Buscar
                  </b-button>

                  <b-button
                    id="btn-limpar"
                    :disabled="isLoading"
                    variant="outline-secondary"
                    @click="reset()"
                  >
                    Limpar
                  </b-button>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
        </b-card-actions>

        <b-card v-if="isSubmitted">
          <b-row
            class="header-card"
            align-v="center"
          >
            <b-col>
              <b-tabs
                ref="tabs"
                v-model="activeTab"
              >
                <b-tab
                  id="tag-automatica"
                  title="Tags Automáticas"
                >
                  <b-row>
                    <b-col cols="12">
                      <b-table
                        :busy="isLoading"
                        responsive
                        :items="results.filter(f => f.tags.filter(f2 => automaticTags.includes(f2)).length > 0 && !f.processed_at)"
                        :fields="result_fields"
                        show-empty
                        sort-icon-left
                        no-local-sorting
                        primary-key="visitor_id"
                      >
                        <template #empty>
                          <h4 class="text-center mt-2 mb-2">
                            Nenhum resultado encontrado
                          </h4>
                        </template>

                        <template #table-busy>
                          <div class="text-center table-spinner">
                            <b-spinner label="Loading..." />
                            <strong>Carregando...</strong>
                          </div>
                        </template>

                        <template #head(selected)>
                          <div class="text-nowrap">
                            <b-form-checkbox
                              :checked="false"
                              @change="toggleAll"
                            />
                          </div>
                        </template>

                        <template #head(status)>
                          <div class="text-nowrap">
                            Status
                          </div>
                        </template>

                        <template #head(campaign)>
                          <div class="text-nowrap">
                            Campanha
                          </div>
                        </template>

                        <template #head(description)>
                          <div class="text-nowrap">
                            Descrição
                          </div>
                        </template>

                        <template #head(actions)>
                          <div class="text-nowrap text-center">
                            Ações
                          </div>
                        </template>

                        <template #cell(selected)="row">
                          <div
                            class="id-select"
                            @click.prevent="onClickSelect(row.item)"
                          >
                            <b-form-checkbox
                              v-if="row.item.chosen.campaign !== 'individual_analysis'"
                              v-model="row.item.selected"
                              :disabled="isSubmitting"
                            />
                          </div>
                        </template>

                        <template #cell(status)="row">
                          <b-badge
                            pill
                            :variant="row.item.processed_at !== null ? 'light-info' : 'light-warning'"
                          >
                            {{ row.item.processed_at ? 'Processado' : 'Pendente' }}
                          </b-badge>
                        </template>

                        <template #cell(id)="row">
                          <div class="text-center">
                            <b-form-input
                              v-model="row.item.chosen.user_id"
                              :disabled="isSubmitting"
                            />
                            <b-button
                              v-if="$can('read', 'Users') && row.item.chosen.user_id !== ''"
                              variant="flat-primary"
                              :to="{ name: 'cms-user-form-update', params: { id: row.item.chosen.user_id } }"
                              title="Editar"
                              target="_blank"
                            >
                              <feather-icon
                                icon="EditIcon"
                                size="16"
                                class="align-middle text-body"
                              />
                            </b-button>
                          </div>
                        </template>

                        <template #cell(campaign)="row">
                          <b-form-group
                            label="Tag"
                          >
                            <b-form-select
                              v-if="row.item.tags.length > 1"
                              v-model="row.item.chosen.tag"
                              :disabled="isSubmitting"
                              :options="row.item.tags.map(m => ({ text: m, value: m, }))"
                              class="ml-1"
                              @change="onChangeTag(row.item)"
                            />
                            <span
                              v-else
                              class="ml-1"
                            >
                              {{ row.item.chosen.tag }}
                            </span>
                          </b-form-group>

                          <b-form-group
                            label="Ação / Campanha"
                          >
                            <b-form-select
                              v-model="row.item.chosen.campaign"
                              :disabled="isSubmitting"
                              :options="campaigns"
                              class="ml-1"
                            />
                          </b-form-group>
                        </template>

                        <template #cell(description)="row">
                          <h4
                            v-if="row.item.error.length > 0"
                            class="text-danger mb-2 d-inline-block"
                          >
                            <feather-icon
                              icon="AlertOctagonIcon"
                              size="18"
                              class="mr-1"
                              alt="Arquivo importado"
                            />{{ row.item.error }}
                            <br>
                          </h4>
                          <div class="mb-2">
                            <span title="Nome do arquivo importado">
                              <feather-icon
                                icon="FileIcon"
                                size="18"
                                class="mr-1"
                                alt="Arquivo importado"
                              />{{ row.item.name }}
                            </span>
                            <br>
                            <span
                              title="Telefone do arquivo importado"
                              class="ml-2 mb-2"
                            >
                              {{ row.item.phone }}
                            </span><br>
                            <span
                              title="E-mail do arquivo importado"
                              class="ml-2"
                            >
                              {{ row.item.email }}
                            </span>
                          </div>
                          <div
                            v-for="user in row.item.users"
                            :key="`tag-automatica-${user.id}`"
                          >
                            <div
                              class="cursor-pointer mb-1"
                              @click="onChangeUser(row.item, user)"
                            >
                              <span>
                                <feather-icon
                                  icon="GlobeIcon"
                                  size="18"
                                  :class="{ 'mr-1': 1 }"
                                />
                              </span>
                              <span
                                title="Usuário encontrado no site"
                                :class="{ 'mr-1': 1, 'text-info': user.found_in === 'users.id' }"
                              >
                                {{ user.id }}
                              </span>
                              <br>
                              <span
                                title="Usuário encontrado no site"
                              >
                                {{ user.name }}
                              </span>
                              <br>
                              <span
                                title="E-mail encontrado no site"
                                :class="{ 'mr-1': 1, 'text-info': user.found_in === 'users.email' }"
                              >
                                {{ user.all_emails ? user.all_emails.split(',').join(', ') : '' }}
                              </span>
                              <br>
                              <span
                                title="Telefone encontrado no site"
                                :class="{ 'mr-1': 1, 'text-info': user.found_in === 'users.phone' }"
                              >
                                {{ user.all_phones ? user.all_phones.split(',').join(', ') : '' }}
                              </span>
                              <br>
                              <span
                                title="Status"
                              >
                                Status: {{ $t(`users.columns.status.${user.status}`) }} - {{ $t(`users.columns.situation.${user.situation}`) }}
                              </span>
                            </div>
                          </div>
                        </template>

                        <template #cell(allEmails)="row">
                          {{ row.item.allEmails.join('\n') }}
                        </template>

                        <template #cell(allPhones)="row">
                          {{ row.item.allPhones.join('\n') }}
                        </template>

                        <template #cell(actions)="row">
                          <div class="text-nowrap text-center">
                            <b-dropdown
                              v-if="$can('read', 'Users')"
                              title="Ações com o usuário"
                              variant="flat-primary"
                            >
                              <b-dropdown-item-button
                                @click="() => handleAssignKanbanDropDown(row.item)"
                              >
                                Atribuir Kanban
                              </b-dropdown-item-button>
                              <b-dropdown-item-button
                                @click="() => handleInvoiceDropDown(row.item)"
                              >
                                Criar ticket de nota fiscal
                              </b-dropdown-item-button>
                              <b-dropdown-item-button
                                v-if="userData.permission_type === 'root'"
                                @click="() => openModalLog(row.item)"
                              >
                                Log
                              </b-dropdown-item-button>
                              <b-dropdown-item-button
                                @click="deleteChatFollow(row.item.visitor_id)"
                              >
                                Remover
                              </b-dropdown-item-button>
                            </b-dropdown>
                          </div>
                        </template>
                      </b-table>
                    </b-col>
                  </b-row>
                </b-tab>

                <b-tab
                  id="tag-chamado"
                  title="Tag Chamado"
                >
                  <b-table
                    :busy="isLoading"
                    responsive
                    :items="results.filter(f => f.tags.filter(f2 => ticketTags.includes(f2)).length > 0 && !f.processed_at)"
                    :fields="result_issue"
                    show-empty
                    sort-icon-left
                    no-local-sorting
                    primary-key="visitor_id"
                  >
                    <template #empty>
                      <h4 class="text-center mt-2 mb-2">
                        Nenhum resultado encontrado
                      </h4>
                    </template>

                    <template #table-busy>
                      <div class="text-center table-spinner">
                        <b-spinner label="Loading..." />
                        <strong>Carregando...</strong>
                      </div>
                    </template>

                    <template #cell(details)="row">
                      <b-badge
                        pill
                        :variant="row.item.processed_at !== null ? 'light-info' : 'light-warning'"
                      >
                        {{ row.item.processed_at ? 'Processado' : 'Pendente' }}
                      </b-badge>
                      <br />
                      <br />
                      <span class="font-weight-bold">Tags: </span>
                      <span>
                        {{ row.item.tags.join(', ') }}
                      </span>
                      <br />
                      <label>Data: </label>
                      <span>{{ row.item.finished_at | date }}</span>
                    </template>

                    <template #cell(chat)="row">
                      <a
                        href="#"
                        @click.prevent="openModalTranscription(row.item)"
                      >
                        Transcrição
                      </a>

                      <br />
                      <br />
                      <a
                        v-if="userData.permission_type === 'root'"
                        href="#"
                        @click.prevent="openModalLog(row.item)"
                      >
                        Log
                      </a>
                    </template>

                    <template #cell(description)="row">
                      <h4
                        v-if="row.item.error.length > 0"
                        class="text-danger mb-2 d-inline-block"
                      >
                        <feather-icon
                          icon="AlertOctagonIcon"
                          size="18"
                          class="mr-1"
                          alt="Arquivo importado"
                        />{{ row.item.error }}
                        <br>
                      </h4>
                      <div class="mb-2">
                        <span title="Nome do arquivo importado">
                          <feather-icon
                            icon="FileIcon"
                            size="18"
                            class="mr-1"
                            alt="Arquivo importado"
                          />{{ row.item.name }}
                        </span>
                        <br>
                        <span
                          title="Telefone do arquivo importado"
                          class="ml-2 mb-2"
                        >
                          {{ row.item.phone }}
                        </span><br>
                        <span
                          title="E-mail do arquivo importado"
                          class="ml-2"
                        >
                          {{ row.item.email }}
                        </span>
                      </div>
                      <div
                        v-for="user in row.item.users"
                        :key="`tag-chamado-${user.id}`"
                      >
                        <div
                          class="cursor-pointer mb-1"
                          @click="onChangeUser(row.item, user)"
                        >
                          <span>
                            <feather-icon
                              icon="GlobeIcon"
                              size="18"
                              :class="{ 'mr-1': 1 }"
                            />
                          </span>
                          <span
                            title="Usuário encontrado no site"
                            :class="{ 'mr-1': 1, 'text-info': user.found_in === 'users.id' }"
                          >
                            {{ user.id }}
                          </span>
                          <br>
                          <span
                            title="Usuário encontrado no site"
                          >
                            {{ user.name }}
                          </span>
                          <br>
                          <span
                            title="E-mail encontrado no site"
                            :class="{ 'mr-1': 1, 'text-info': user.found_in === 'users.email' }"
                          >
                            {{ user.all_emails ? user.all_emails.split(',').join(', ') : '' }}
                          </span>
                          <br>
                          <span
                            title="Telefone encontrado no site"
                            :class="{ 'mr-1': 1, 'text-info': user.found_in === 'users.phone' }"
                          >
                            {{ user.all_phones ? user.all_phones.split(',').join(', ') : '' }}
                          </span>
                          <br>
                          <span
                            title="Status"
                          >
                            Status: {{ $t(`users.columns.status.${user.status}`) }} - {{ $t(`users.columns.situation.${user.situation}`) }}
                          </span>
                        </div>
                      </div>
                    </template>

                    <template #cell(id)="row">
                      <div class="text-center">
                        <b-form-input
                          v-model="row.item.chosen.user_id"
                          :disabled="isSubmitting"
                          @blur="loadNewUser(row.item)"
                        />
                        <b-button
                          v-if="$can('read', 'Users') && row.item.chosen.user_id !== ''"
                          variant="flat-primary"
                          :to="{ name: 'cms-user-form-update', params: { id: row.item.chosen.user_id } }"
                          title="Editar"
                          target="_blank"
                        >
                          <feather-icon
                            icon="EditIcon"
                            size="16"
                            class="align-middle text-body"
                          />
                        </b-button>
                      </div>
                    </template>

                    <template #cell(actions)="row">
                      <b-button
                        variant="flat-primary"
                        title="Remover"
                        target="_blank"
                        @click="deleteChatFollow(row.item.visitor_id)"
                      >
                        <feather-icon
                          icon="TrashIcon"
                          size="16"
                          class="align-middle text-body"
                        />
                      </b-button>
                    </template>
                  </b-table>
                </b-tab>

                <b-tab
                  id="tag-venda"
                  title="Tag Vendas"
                >
                  <b-table
                    :busy="isLoading"
                    responsive
                    :items="results.filter(f => f.tags.filter(f2 => salesTags.includes(f2)).length > 0 && !f.lead_at && (f.users.length === 0 || (f.users[0].situation === 'free' && f.users[0].status !== 'lead')))"
                    :fields="result_fields_sales"
                    show-empty
                    sort-icon-left
                    no-local-sorting
                    primary-key="visitor_id"
                  >
                    <template #empty>
                      <h4 class="text-center mt-2 mb-2">
                        Nenhum resultado encontrado
                      </h4>
                    </template>

                    <template #table-busy>
                      <div class="text-center table-spinner">
                        <b-spinner label="Loading..." />
                        <strong>Carregando...</strong>
                      </div>
                    </template>

                    <template #cell(details)="row">
                      <b-badge
                        pill
                        :variant="row.item.processed_at !== null ? 'light-info' : 'light-warning'"
                      >
                        {{ row.item.processed_at ? 'Processado' : 'Pendente' }}
                      </b-badge>
                      <br />
                      <br />
                      <span class="font-weight-bold">Tags: </span>
                      <span>{{ row.item.tags.join(', ') }}</span>
                      <br />

                      <span class="font-weight-bold">Data: </span>
                      <span>{{ row.item.finished_at | date }}</span>
                    </template>

                    <template #cell(chat)="row">
                      <a
                        href="#"
                        @click.prevent="openModalTranscription(row.item)"
                      >
                        Transcrição
                      </a>
                      <br />
                      <br />
                      <a
                        href="#"
                        @click.prevent="openModalRecommendation(row.item)"
                      >
                        Recomendação de conduta
                      </a>

                      <br />
                      <br />
                      <a
                        v-if="userData.permission_type === 'root'"
                        href="#"
                        @click.prevent="openModalLog(row.item)"
                      >
                        Log
                      </a>
                    </template>

                    <template #cell(description)="row">
                      <h4
                        v-if="row.item.error.length > 0"
                        class="text-danger mb-2 d-inline-block"
                      >
                        <feather-icon
                          icon="AlertOctagonIcon"
                          size="18"
                          class="mr-1"
                          alt="Arquivo importado"
                        />{{ row.item.error }}
                        <br>
                      </h4>
                      <div class="mb-2">
                        <span title="Nome do arquivo importado">
                          <feather-icon
                            icon="FileIcon"
                            size="18"
                            class="mr-1"
                            alt="Arquivo importado"
                          />{{ row.item.name }}
                        </span>
                        <br>
                        <span
                          title="Telefone do arquivo importado"
                          class="ml-2 mb-2"
                        >
                          {{ row.item.phone }}
                        </span><br>
                        <span
                          title="E-mail do arquivo importado"
                          class="ml-2"
                        >
                          {{ row.item.email }}
                        </span>
                      </div>
                      <div
                        v-for="user in row.item.users"
                        :key="`tag-venda-${user.id}`"
                      >
                        <div
                          class="cursor-pointer mb-1"
                          @click="onChangeUser(row.item, user)"
                        >
                          <span>
                            <feather-icon
                              icon="GlobeIcon"
                              size="18"
                              :class="{ 'mr-1': 1 }"
                            />
                          </span>
                          <span
                            title="Usuário encontrado no site"
                            :class="{ 'mr-1': 1, 'text-info': user.found_in === 'users.id' }"
                          >
                            {{ user.id }}
                          </span>
                          <br>
                          <span
                            title="Usuário encontrado no site"
                          >
                            {{ user.name }}
                          </span>
                          <br>
                          <span
                            title="E-mail encontrado no site"
                            :class="{ 'mr-1': 1, 'text-info': user.found_in === 'users.email' }"
                          >
                            {{ user.all_emails ? user.all_emails.split(',').join(', ') : '' }}
                          </span>
                          <br>
                          <span
                            title="Telefone encontrado no site"
                            :class="{ 'mr-1': 1, 'text-info': user.found_in === 'users.phone' }"
                          >
                            {{ user.all_phones ? user.all_phones.split(',').join(', ') : '' }}
                          </span>
                          <br>
                          <span
                            title="Status"
                          >
                            Status: {{ $t(`users.columns.status.${user.status}`) }} - {{ $t(`users.columns.situation.${user.situation}`) }}
                          </span>
                        </div>
                      </div>
                    </template>

                    <template #cell(id)="row">
                      <div class="text-center">
                        <b-form-input
                          v-model="row.item.chosen.user_id"
                          :disabled="isSubmitting"
                          @blur="loadNewUser(row.item)"
                        />
                        <b-button
                          v-if="$can('read', 'Users') && row.item.chosen.user_id !== ''"
                          variant="flat-primary"
                          :to="{ name: 'cms-user-form-update', params: { id: row.item.chosen.user_id } }"
                          title="Editar"
                          target="_blank"
                        >
                          <feather-icon
                            icon="EditIcon"
                            size="16"
                            class="align-middle text-body"
                          />
                        </b-button>
                      </div>
                    </template>

                    <template #cell(actions)="row">
                      <div class="text-nowrap text-center">
                        <b-dropdown
                          v-if="$can('read', 'Users')"
                          title="Ações com o usuário"
                          variant="flat-primary"
                        >
                          <b-dropdown-item-button
                            @click="handleAssignKanbanDropDown(row.item, 'tab-sales')"
                          >
                            Atribuir Kanban
                          </b-dropdown-item-button>
                          <b-dropdown-item-button
                            @click="deleteChatFollow(row.item.visitor_id)"
                          >
                            Remover
                          </b-dropdown-item-button>
                        </b-dropdown>
                      </div>
                    </template>
                  </b-table>
                </b-tab>

                <b-tab
                  id="whatsapp"
                  title="WhatsApp"
                >
                  <b-table
                    :busy="isLoadingWhatsappChats"
                    responsive
                    :items="whatsappChatResults"
                    :fields="result_fields_whatsapp_chats"
                    show-empty
                    sort-icon-left
                    no-local-sorting
                    primary-key="visitor_id"
                  >
                    <template #empty>
                      <h4 class="text-center mt-2 mb-2">
                        Nenhum resultado encontrado
                      </h4>
                    </template>

                    <template #cell(link)="row">
                      <a :href="`https://enterprise-49.clickmassa.com.br/#/atendimento/${row.item.ticket_id}?t=1753708854234`">Abrir no ClickMassa</a>
                    </template>

                    <template #cell(tags)="row">
                      {{ row.item.tags && row.item.tags.length > 0 ? row.item.tags.join(', ') : '' }}
                    </template>

                    <template #cell(transcript)="row">
                      <a
                        href="#"
                        @click.prevent="openModalTranscriptionFromWhatsappChats(row.item)"
                      >Transcrição</a>
                    </template>
                  </b-table>
                </b-tab>
              </b-tabs>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <div
      class="btn-scroll-to-top text-right show"
    >
      <b-button
        variant="primary"
        class="mr-1"
        :disabled="isSubmitting || selectedUsers.length === 0"
        @click="handleProcessChosen"
      >
        <b-spinner
          v-if="isSubmitting "
          small
        />
        Processar Selecionados
      </b-button>

      <b-button
        variant="primary"
        :disabled="isSubmitting || selectedUsers.length === 0"
        @click="handleAssignKanban(selectedUsers)"
      >
        <b-spinner
          v-if="isSubmitting"
          small
        />
        Atribuir Kanban aos Selecionados
      </b-button>
    </div>

    <b-modal
      ref="recommendation-modal"
      size="lg"
      ok-title="Aprovar recomendação"
      cancel-title="Cancelar recomendação"
      title="Recomendação de conduta"
      @ok="canUseRecommendation(true)"
      @cancel="canUseRecommendation(false)"
    >
      <!-- eslint-disable vue/no-v-html -->
      <p v-html="conductRecommendation"></p>
    </b-modal>

    <b-modal
      ref="transcript-whatsapp"
      size="lg"
      hide-footer
      title="Transcrição do Chat no WhatsApp"
    >
      <h3>Transcrição</h3>
      <!-- eslint-disable vue/no-v-html -->
      <p v-html="selectedRow.transcript"></p>
    </b-modal>

    <b-modal
      ref="log-modal"
      size="lg"
      hide-footer
      title="Log de decisões"
    >
      <div
        v-for="(data, index) in selectedRow.processed_data"
        :key="`log-data-${index}`"
      >
        <div
          v-for="(item, index2) in entries(data)"
          :key="`log-data-2-${index2}`"
        >
          <label class="font-medium-1 font-weight-bold">{{ item[0] }}: </label>

          <span v-if="item[0] === 'data'"> {{ moment(item[1]).format('DD/MM/YYYY HH:mm:ss') }}</span>
          <span v-if="item[0] !== 'data'"> {{ item[1] }}</span>
        </div>
        <hr />

      </div>
    </b-modal>

    <b-modal
      ref="transcript-modal"
      size="lg"
      hide-footer
      title="Transcrição do Chat"
    >
      <h3>Transcrição</h3>
      <!-- eslint-disable vue/no-v-html -->
      <p v-html="transcript"></p>

      <h3>Dados de apoio</h3>
      <span v-if="isLoadingSupportingData"><b-spinner small></b-spinner></span>
      <ul v-if="!isLoadingSupportingData">
        <li>Mensagens enviadas (30 dias/todo período): {{ supportingData.messages_sent }}/{{ supportingData.messages_sent_all }} </li>
        <li>Mensagens recebidas (30 dias/todo período): {{ supportingData.messages_received }}/{{ supportingData.messages_received_all }} </li>
        <li>Logins (30 dias/todo período): {{ supportingData.logins }}/{{ supportingData.logins_all }} </li>
        <li>Tem plano ativo: {{ supportingData.have_plan ? 'sim' : 'não' }} </li>
        <li>Já teve um plano: {{ supportingData.has_plan ? 'sim' : 'não' }} </li>
      </ul>

      <h3>Resposta</h3>
      <b-form-checkbox
        v-model="sendByEmail"
        class="mr-1"
        variant="secondary"
        switch
      >
        <span title="">Enviar por e-mail</span>
      </b-form-checkbox>

      <div
        v-if="sendByEmail"
        class="p-2 mb-2 border rounded rounded-4"
      >
        <b-row>
          <b-col
            v-for="(email, index) in selectedRowEmails"
            :key="`${index}-${email.email}`"
            cols="6"
          >
            <b-form-checkbox
              v-model="email.selected"
              :disabled="isLoadingIssueAnswer || isLoadingIssueAnswer"
              class="mr-1"
              variant="secondary"
              switch
            >
              <span title="Mostrar Calendário">E-mail {{ email.type }}<br /> {{ email.email }}</span>
            </b-form-checkbox>
          </b-col>
        </b-row>

        <validation-observer ref="rulesTranscript">
          <h3>Texto da resposta</h3>
          <validation-provider
            #default="{ errors }"
          >
            <b-form-group
              label=""
            >
              <b-form-textarea
                id="issue_text"
                v-model="issueTextEmail"
                rows="10"
                :disabled="isLoadingTranscript || isLoadingIssueAnswer"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>

          <b-row>
            <b-col
              cols="12"
              class="d-flex justify-content-end flex-wrap align-content-end"
            >
              <b-button
                variant="primary"
                :disabled="isLoadingTranscript || isLoadingIssueAnswer || selectedRowEmails.filter(f => f.selected).length === 0"
                @click="approveAndSendText('email')"
              >
                <b-spinner
                  v-if="isLoadingTranscript || isLoadingIssueAnswer"
                  small
                />
                Enviar e-mail
              </b-button>
            </b-col>
          </b-row>

          <h3>Contexto</h3>
          <validation-provider
            #default="{ errors }"
          >
            <b-form-group
              label="Adicionar contexto ao prompt"
            >
              <b-form-textarea
                id="annotation"
                v-model="inputFormContextEmail"
                rows="3"
                :disabled="isLoadingTranscript || isLoadingIssueAnswer"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>

          <b-row>
            <b-col
              cols="12"
              class="d-flex justify-content-end flex-wrap align-content-end"
            >
              <b-button
                variant="primary"
                :disabled="isLoadingTranscript || isLoadingIssueAnswer"
                @click="getNewPrompt('email')"
              >
                <b-spinner
                  v-if="isLoadingTranscript || isLoadingIssueAnswer"
                  small
                />
                Escrever nova resposta com contexto
              </b-button>
            </b-col>
          </b-row>
        </validation-observer>
      </div>

      <b-form-checkbox
        v-model="sendByWhats"
        class="mr-1"
        variant="secondary"
        switch
      >
        <span title="">Enviar por whatsapp</span>
      </b-form-checkbox>

      <div
        v-if="sendByWhats"
        class="p-2 border rounded-2"
      >
        <b-row>
          <b-col
            v-for="(phone, index) in selectedRowPhones"
            :key="`${index}-${phone.phone}`"
            cols="6"
          >
            <b-form-checkbox
              v-model="phone.selected"
              :disabled="isLoadingTranscript || isLoadingIssueAnswer"
              class="mr-1"
              variant="secondary"
              switch
            >
              <span title="">Telefone {{ phone.type }}<br /> {{ phone.phone }}</span>
            </b-form-checkbox>
          </b-col>
        </b-row>

        <validation-observer ref="rulesTranscript">
          <h3>Texto da resposta</h3>
          <validation-provider
            #default="{ errors }"
          >
            <b-form-group
              label=""
            >
              <b-form-textarea
                id="issue_text"
                v-model="issueTextWhats"
                rows="10"
                :disabled="isLoadingTranscript || isLoadingIssueAnswer"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>

          <b-row>
            <b-col
              cols="12"
              class="d-flex justify-content-end flex-wrap align-content-end"
            >
              <b-button
                variant="primary"
                :disabled="isLoadingTranscript || isLoadingIssueAnswer || selectedRowPhones.filter(f => f.selected).length === 0"
                @click="approveAndSendText('whatsapp')"
              >
                <b-spinner
                  v-if="isLoadingTranscript || isLoadingIssueAnswer"
                  small
                />
                Enviar whatsapp
              </b-button>
            </b-col>
          </b-row>

          <h3>Contexto</h3>
          <validation-provider
            #default="{ errors }"
          >
            <b-form-group
              label="Adicionar contexto ao prompt"
            >
              <b-form-textarea
                id="annotation"
                v-model="inputFormContextWhats"
                rows="3"
                :disabled="isLoadingTranscript || isLoadingIssueAnswer"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>

          <b-row>
            <b-col
              cols="12"
              class="d-flex justify-content-end flex-wrap align-content-end"
            >
              <b-button
                variant="primary"
                :disabled="isLoadingTranscript || isLoadingIssueAnswer"
                @click="getNewPrompt('whatsapp')"
              >
                <b-spinner
                  v-if="isLoadingTranscript"
                  small
                />
                Escrever nova resposta com contexto
              </b-button>
            </b-col>
          </b-row>
        </validation-observer>
      </div>
    </b-modal>

    <b-modal
      ref="move-card-modal"
      hide-footer
    >
      <move-card :data="cardData" />
    </b-modal>

    <b-modal
      ref="assign-kanban-modal"
      hide-footer
      size="lg"
      title="Atribuir Kanban"
      :no-close-on-backdrop="preventCloseModal"
      :no-close-on-esc="preventCloseModal"
      :hide-header-close="preventCloseModal"
    >
      <modal-assign-kanban
        :data="dataAssignKanban"
        :origin="originAssignKanban"
        @prevent-close-modal="changePreventCloseModal"
        @hide="hideAssignKanbanModal"
        @force-data-assign-kanban="handleAssignKanban"
        @assigned-users="handleAssignedUsers"
      />
    </b-modal>

  </section>
</template>

<style lang="scss" scoped>
  .btn.disabled {
    background-color: #f38493!important;
    border-color: #f38493!important;
    opacity: 1;
  }

  .btn-scroll-to-top {
    position: fixed;
    bottom: 5%;
    right: 80px;
    z-index: 99;

    opacity: 0;
    // transform: translateY(100px);
    transition: all .5s ease;

    &.show {
      opacity: 1;
      // transform: translateY(0)
    }
  }
</style>

<script>
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import UserService from '@/services/userService'
import ChatFollowService from '@/services/chatFollowService'
import IssueService from '@/services/issueService'
import { formatDateTimeDbToView } from '@/utils/helpers'
import { markdown } from '@/utils/drawdown'
import {
  BRow,
  BCol,
  BTable,
  BTab,
  BTabs,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BSpinner,
  BButton,
  BCard,
  BBreadcrumb,
  BDropdown,
  BDropdownItemButton, BFormTextarea, BBadge,
} from 'bootstrap-vue'
import toast from '@/mixins/toast'
import swall from '@/mixins/swall'
import SusiService from '@/services/susiService'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import WhatsappChatService from '@/services/whatsappChatService'
import moment from 'moment'
import ModalAssignKanban from '../active-users/ModalAssignKanban.vue'
import MoveCard from '../../kanban/MoveCard.vue'

export default {
  components: {
    BBadge,
    BFormTextarea,
    BCardActions,
    BCard,
    BRow,
    BTabs,
    BTab,
    BCol,
    BTable,
    BFormInput,
    BFormCheckbox,
    BFormSelect,
    BFormGroup,
    BSpinner,
    BButton,
    BBreadcrumb,
    BDropdown,
    BDropdownItemButton,
    ModalAssignKanban,
    MoveCard,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [
    toast,
    swall,
  ],
  data() {
    return {
      moment,
      required,
      activeTab: 0,
      chatId: null,
      tabs: [
        'tag-automatica',
        'tag-chamado',
        'tag-venda',
        'whatsapp',
      ],
      sendByEmail: false,
      sendByWhats: false,
      userService: null,
      chatFollowService: null,
      isLoading: false,
      isLoadingTranscript: false,
      isLoadingIssueAnswer: false,
      isLoadingSupportingData: false,
      isLoadingSetRecommendation: false,
      isLoadingWhatsappChats: false,
      isSubmitted: true,
      isSubmitting: false,
      selectedUserIds: [],
      files: [],
      selectedFile: '-',
      file: null,
      cardData: {},
      breadcrumb: [
        {
          text: 'Dashboard',
          to: { name: 'cms-dashboard' },
        },
        {
          text: 'Ferramentas',
          active: true,
        },
        {
          text: 'Acompanhamento pós Chat',
          active: true,
        },
      ],

      chosen: [],
      pages: 1,
      currentPage: 1,
      results: [],
      whatsappChatResults: [],
      actionsList: [],
      result_fields: [
        { key: 'selected', sortable: false, thStyle: 'width: 20px', tdClass: 'no-padding' },
        { key: 'id', sortable: false, thStyle: 'width: 150px' },
        { key: 'status', sortable: false, thStyle: 'width: 150px' },
        { key: 'description', sortable: false },
        { key: 'campaign', sortable: false },
        { key: 'actions', sortable: false, thStyle: 'width: 180px' },
      ],
      result_fields_sales: [
        { key: 'id', sortable: false, thStyle: 'width: 150px' },
        { key: 'description', label: 'Descrição', sortable: false },
        { key: 'details', label: 'Detalhes', sortable: false, thStyle: 'width: 200px' },
        { key: 'chat', sortable: false },
        { key: 'actions', label: 'Ações', sortable: false, thStyle: 'width: 180px' },
      ],
      result_fields_whatsapp_chats: [
        { key: 'ticket_id', label: 'Ticket ID', sortable: false, thStyle: 'width: 150px' },
        { key: 'link', sortable: false },
        { key: 'tags', sortable: false },
        { key: 'bot_name', label: 'Bot', sortable: false },
        { key: 'transcript', label: 'Transcrição', sortable: false },
        { key: 'actions', label: 'Ações', sortable: false, thStyle: 'width: 180px' },
      ],
      result_issue: [
        { key: 'id', sortable: false, thStyle: 'width: 150px' },
        { key: 'description', label: 'Descrição', sortable: false, thStyle: 'width: 200px' },
        { key: 'details', label: 'Detalhes', sortable: false },
        { key: 'chat', sortable: false },
        { key: 'actions', label: 'Ações', sortable: false, thStyle: 'width: 180px' },
      ],
      ticketTags: [
        'debater',
        'sugestão',
        'descarte',
        'onboarding',
        'chamado',
      ],
      // vem do backend, não é mais utilizado
      salesTags: [
        'venda',
        'login',
        'atualizar',
        'busca',
      ],
      automaticTags: [
        'busca',
        'login',
        'atualizar',
        'cadastro',
        'cadastro-empresa',
        'acompanhamento',
        'duplo',
        'mensagem',
        'gratuito',
        'discussão',
        'nf',
        'cancelar cadastro',
        'cancelar assinatura',
      ],
      inputFormContextEmail: '',
      inputFormContextWhats: '',
      issueAnswerBy: {
        chatEmail: false,
        chatWhatsApp: false,
        userEmail: false,
        userWhatsApp: false,
      },
      responseType: 'email',
      responseOptions: [
        { value: 'email', text: 'E-mail' },
        { value: 'whatsapp', text: 'WhatsApp' },
      ],
      userId: '',
      settings: {},
      supportingData: {
        messages_sent: 0,
        messages_sent_all: 0,
        messages_received: 0,
        messages_received_all: 0,
        logins: 0,
        logins_all: 0,
        have_plan: 0,
        has_plan: 0,
      },
      selectedRowEmails: [],
      selectedRowPhones: [],
      selectedRow: {
        issue_text: '',
        issue_text_whats: '',
        tags: [],
        visitor_id: 0,
        conduct_recommendation: '',
      },
      transcript: '',
      conductRecommendation: '',
      issueTextEmail: '',
      issueTextWhats: '',
      campaigns: [
        {
          text: 'Tickets',
          options: [
            {
              text: 'Ticket',
              value: 'ticket',
            },
            {
              text: 'Ticket de Nota Fiscal',
              value: 'ticket_nf',
            },
            {
              text: 'Ticket de Cancelar Cadastro',
              value: 'ticket_register_cancel',
            },
            {
              text: 'Ticket de Cancelar Assinatura',
              value: 'ticket_subscription_cancel',
            },
          ],
        },
        {
          text: 'Outros',
          options: [
            {
              text: 'Análise individual',
              value: 'individual_analysis',
            },
            {
              text: 'Aguardar / Nada a Fazer',
              value: 'await',
            },
          ],
        },
        {
          text: 'Usuário',
          options: [
            // {
            //   text: 'Cancelar Cadastro',
            //   value: 'user.new_lead',
            // },
            // {
            //   text: 'Cancelar Assinatura',
            //   value: 'user.new_lead',
            // },
            // {
            //   text: 'Bloquear Cadastro',
            //   value: 'user.new_lead',
            // },
            {
              text: 'Virar Status Lead - Empresa',
              value: 'user.lead_company',
            },
            {
              text: 'Virar Status Lead - Representante',
              value: 'user.lead_representative',
            },
          ],
        },
        {
          text: 'Mailchimp',
          options: [
            {
              text: 'Atualizar',
              value: 'mailchimp.update',
            },
            {
              text: 'Busca',
              value: 'mailchimp.search',
            },
            {
              text: 'Duplo',
              value: 'mailchimp.double',
            },
            {
              text: 'Gratuito',
              value: 'mailchimp.free',
            },
            {
              text: 'Login',
              value: 'mailchimp.login',
            },
            {
              text: 'Mensagem',
              value: 'mailchimp.message',
            },
            {
              text: 'Monitoramento',
              value: 'mailchimp.monitoring',
            },
            {
              text: 'Reativação',
              value: 'mailchimp.reactivation',
            },
            {
              text: 'Sugestão',
              value: 'mailchimp.suggestion',
            },
          ],
        },
      ],
      formatDateTimeDbToView,
      preventCloseModal: false,
      dataAssignKanban: null,
      originAssignKanban: null,
    }
  },
  computed: {
    selectedUsers() {
      return this.results.filter(f => f.selected && f.chosen.campaign !== 'individual_analysis').map(m => ({
        id: m.chosen.user_id,
        name: m.name,
      }))
    },
  },

  watch: {
    currentPage() {
      this.getUsers()
    },
  },

  async created() {
    this.userService = new UserService()
    this.chatFollowService = new ChatFollowService()
    this.activeTab = this.tabs.indexOf(this.tab)

    this.isLoading = true

    const userDataString = await localStorage.getItem('userData')
    this.userData = await JSON.parse(userDataString)

    await this.getWhatsapps()
    await this.getFiles()

    if (this.$route.params.tab && this.$route.params.chatId) {
      this.chatId = this.$route.params.chatId
      await this.getChat(this.chatId)

      if (this.results.length === 0) {
        this.swallError('Chamado não encontrado', 'Pode ter sido removido manualmente', 'Ok')
      } else if (this?.results[0]?.tags.includes('chamado')) {
        this.activeTab = this.tabs.indexOf('tag-chamado')
      } else if (this?.results[0]?.tags.includes('venda') || this?.results[0]?.tags.includes('login') || this?.results[0]?.tags.includes('atualizar') || this?.results[0]?.tags.includes('busca')) {
        this.activeTab = this.tabs.indexOf('tag-venda')
      } else {
        this.activeTab = this.tabs.indexOf('tag-automatica')
      }
    }

    this.isLoading = false
  },

  methods: {
    entries(data) {
      return Object.entries(data)
    },
    async getWhatsapps() {
      this.isLoadingWhatsappChats = true

      const filters = {
        from: moment().subtract(1, 'days').format('YYYY-MM-DD 00:00:00'),
        to: moment().format('YYYY-MM-DD 23:59:59'),
      }
      return WhatsappChatService.listToChatFollow(filters).then(response => {
        this.whatsappChatResults = response.data.data.chats
      }).catch(() => {
        this.toastDanger('Erro!', 'Nenhuma conversa de WhatsApp encontrada.')
      }).finally(() => {
        this.isLoadingWhatsappChats = false
      })
    },

    async getNewPrompt(type) {
      const supportingDataString = `**Dados de apoio**:
Mensagens enviadas: ${this.supportingData.messages_sent}
Mensagens recebidas: ${this.supportingData.messages_received}
Logins: ${this.supportingData.logins}
Tem plano ativo: ${this.supportingData.have_plan}
Já teve um plano: ${this.supportingData.has_plan}
`
      let response = null
      const inputFormContext = `${type === 'email' ? this.inputFormContextEmail : this.inputFormContextWhats}\n**Transcrição do chat**:\n${this.transcript}`
      const inputFormAnswer = `Resposta atual: ${type === 'email' ? this.issueTextEmail : this.issueTextWhats}`

      this.$refs.rulesTranscript.validate().then(async success => {
        if (success) {
          this.isLoadingTranscript = true

          response = await SusiService.byPrompt(`susi-prompt-chat-follow-chamado-${type}`, {
            dados_de_apoio: supportingDataString,
            contexto_adicional: inputFormContext,
            // transcricao: `**Transcrição do chat**:\n${this.transcript}`,
            transcricao: inputFormAnswer,
          })

          if (response.data.data.success) {
            // this.issueText = markdown(response.data.data.response)

            // salvar a nova recomendação no item
            this.selectedRow.issue_text = response.data.data.response
            this.selectedRow.issue_text_approved = true

            if (type === 'email') {
              this.issueTextEmail = response.data.data.response
              await this.chatFollowService.saveNewIssueText(this.selectedRow.visitor_id, this.selectedRow.issue_text)
            } else {
              this.issueTextWhats = response.data.data.response
              await this.chatFollowService.saveNewIssueTextWhats(this.selectedRow.visitor_id, this.selectedRow.issue_text)
            }
          }
          // refazer recomendação de conduta
          // response = await SusiService.byPrompt('susi-prompt-chat-follow-recomendacao-conduta', {
          //   dados_de_apoio: supportingDataString,
          //   contexto_adicional: inputFormContext,
          //   transcricao: `**Transcrição do chat**:\n${this.transcript}`,
          // })
          //
          // if (response.data.data.success) {
          //   this.conductRecommendation = markdown(response.data.data.response)
          //
          //   // salvar a nova recomendação no item
          //   this.selectedRow.conduct_recommendation = response.data.data.response
          //
          //   // salvar a nova recomendação na base
          //   await this.chatFollowService.saveNewConductRecommendation(this.selectedRow.visitor_id, this.selectedRow.conduct_recommendation)
          //   this.$refs['transcript-modal'].hide()
          //   this.$refs['recommendation-modal'].show()
          // }
        } else {
          this.toastDanger('Erro de validação', 'Preencha corretamente os campos')
        }
        this.isLoadingTranscript = false
      })
    },

    deleteChatFollow(chatId) {
      this.$swal({
        title: 'Remover do relatório?',
        text: 'Esta ação não poderá ser desfeita!',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Sim, remover!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.isLoading = true
          this.chatFollowService.removeChat(chatId).then(response => {
            if (response.status === 200) {
              this.results = this.results.filter(filter => filter.visitor_id !== chatId)
              this.toastSuccess('Linha removida do relatório!')
            }
          })
        }
      }).finally(() => {
        this.isLoading = false
      }).catch(error => {
        this.toastDanger(error.response.data.message)
      })
    },

    async openModalTranscriptionFromWhatsappChats(row) {
      this.selectedRow = row
      this.selectedRow.transcript = row.transcript.replaceAll('\n', '<br />')
      this.$refs['transcript-whatsapp'].show()
    },

    async openModalLog(row) {
      this.selectedRow = row
      this.$refs['log-modal'].show()
    },

    async openModalTranscription(row) {
      // obter os dados de apoio do chatFollow
      this.isLoadingSupportingData = true
      this.selectedRow = row

      //
      // telefone
      //
      this.selectedRowPhones = [
        {
          type: 'do chat',
          selected: false,
          phone: this.selectedRow.phone,
        },
        {
          type: 'principal',
          selected: false,
          phone: this.selectedRow?.users[0]?.cell_phone ?? '',
        },
      ]
      if (this.selectedRow?.users[0]?.phones) {
        const uniques = [...new Set(this.selectedRow.users[0].phones)]
        uniques.forEach(e => {
          if (this.selectedRowPhones.filter(f => f.phone === e).length === 0) {
            this.selectedRowPhones.push({
              type: 'adicional',
              selected: false,
              phone: e,
            })
          }
        })
      }

      //
      // emails
      //
      this.selectedRowEmails = [
        {
          type: 'do chat',
          selected: false,
          email: this.selectedRow.email,
        },
        {
          type: 'principal',
          selected: false,
          email: this.selectedRow?.users[0]?.email ?? '',
        },
      ]
      if (this.selectedRow?.users[0]?.emails) {
        const uniques = [...new Set(this.selectedRow.users[0].emails)]
        uniques.forEach(e => {
          if (this.selectedRowEmails.filter(f => f.email === e).length === 0) {
            this.selectedRowEmails.push({
              type: 'adicional',
              selected: false,
              email: e,
            })
          }
        })
      }

      const transcript = row.transcript ? row.transcript : ''
      this.transcript = transcript.replaceAll('\n', '<br /><br />')

      this.issueTextEmail = row.issue_text ? row.issue_text : ''
      this.issueTextWhats = row.issue_text_whats ? row.issue_text_whats : ''

      this.$refs['transcript-modal'].show()

      const response = await this.chatFollowService.getSupportingData(row.chosen.user_id)
      this.supportingData = response.data.data

      this.isLoadingSupportingData = false
    },

    async canUseRecommendation(value) {
      this.isLoadingSetRecommendation = true
      this.selectedRow.chosen.isRecommendationReleased = value
      await this.chatFollowService.setApprovedConductRecommendation(this.selectedRow.visitor_id, this.selectedRow.chosen.user_id, value ? 1 : 0)
      this.isLoadingSetRecommendation = false
    },

    openModalRecommendation(row) {
      this.selectedRow = row
      const recommendation = row.conduct_recommendation ? row.conduct_recommendation : ''
      this.conductRecommendation = markdown(recommendation)
      this.$refs['recommendation-modal'].show()
    },

    async approveAndSendText(type) {
      let list = []
      let issueText = ''
      if (type === 'email') {
        issueText = this.issueTextEmail
        list = this.selectedRowEmails.filter(f => f.selected).map(m => (m.email))
      } else {
        issueText = this.issueTextWhats
        list = this.selectedRowPhones.filter(f => f.selected).map(m => (m.phone))
      }

      this.isLoadingIssueAnswer = true
      this.chatFollowService.sendIssueAnswer(
        this.selectedRow.visitor_id,
        issueText,
        this.selectedRow.chosen.user_id,
        type,
        list,
      ).then(() => {
        this.results = this.results.filter(f => f.visitor_id !== this.selectedRow.visitor_id)
      }).finally(() => {
        if (type === 'email') {
          this.toastSuccess('E-mail enviado!')
        } else {
          this.toastSuccess('Whats enviado!')
        }
        this.isLoadingIssueAnswer = false
        this.$refs['transcript-modal'].hide()
      })
    },

    getFiles() {
      return this.chatFollowService.getFiles().then(response => {
        this.files = [{
          value: '-',
          text: 'Todos',
        }, {
          value: 'most-recent',
          text: 'Últimas 48 horas',
        },
        ...response.data.data.files.map(m => ({
          value: m,
          text: m,
        }))]
      })
    },

    openDefaultChatFollow() {
      this.$router.push({ name: 'cms-tools-chat-follow', params: { } }).catch(() => {

      })
    },

    reset() {
      this.results = []
      this.file = null
      this.isSubmitted = false
    },

    onClickSelect(item) {
      // eslint-disable-next-line no-param-reassign
      item.selected = !item.selected
    },

    onChangeTag(item) {
      const user = item.users.find(f => f.id === item.chosen.user_id)
      // eslint-disable-next-line no-param-reassign
      item.chosen.campaign = this.getCampaign(item.chosen.tag, user)
    },

    loadNewUser(item) {
      this.chatFollowService.loadUser(item.chosen.user_id).then(response => {
        // eslint-disable-next-line no-param-reassign
        item.issue_text = ''
        // eslint-disable-next-line no-param-reassign
        item.users[0] = response.data.data.user
        this.$forceUpdate()
      })
    },

    onChangeUser(item, user) {
      // eslint-disable-next-line no-param-reassign
      item.chosen.user_id = user.id
      // eslint-disable-next-line no-param-reassign
      item.chosen.campaign = this.getCampaign(item.chosen.tag, user)
    },

    dynamicSortMultiple(props) {
      return (obj1, obj2) => {
        let i = 0
        let result = 0
        const numberOfProperties = props.length
        while (result === 0 && i < numberOfProperties) {
          result = this.dynamicSort(props[i])(obj1, obj2)
          i += 1
        }
        return result
      }
    },

    dynamicSort(props) {
      let sortOrder = 1
      let property = props
      if (property[0] === '-') {
        sortOrder = -1
        property = property.substr(1)
      }
      // eslint-disable-next-line no-unused-vars
      return (a, b) => {
        // eslint-disable-next-line no-nested-ternary,no-eval
        const result = (eval(`a.${property}`) < eval(`b.${property}`)) ? -1 : (eval(`a.${property}`) > eval(`b.${property}`)) ? 1 : 0
        return result * sortOrder
      }
    },

    getUsers() {
      if (this.isLoading) {
        return false
      }
      const formData = new FormData()
      formData.append('userId', this.userId)
      formData.append('selectedFile', this.selectedFile)

      this.isSubmitted = true
      this.isLoading = true
      this.chatFollowService.sendFile(formData).then(response => {
        if (response.data !== null) {
          this.actionsList = response.data.data['chat-follow']['actions-list']
          this.results = response.data.data['chat-follow'].users.map(m => ({
            ...m,
            selected: false,
            error: '',
            issue_text_approved: false,
            chosen: {
              user_id: m.users.length ? m.users[0].id : '',
              tag: m.tags[0],
              campaign: this.getCampaign(m.tags[0], m.users[0] ?? null),
              isRecommendationReleased: false,
            },
          }))

          this.results.sort(this.dynamicSortMultiple(['chosen.campaign']))
        } else {
          this.toastDanger('Ops!', 'Nenhum resultado encontrado com os termos pesquisados')
        }
      }).catch(() => {
        this.toastDanger('Erro!', 'Nenhum chat encontrado com os termos pesquisados')
      }).finally(() => {
        this.isLoading = false
      })

      return true
    },

    getChat(chatId) {
      this.isSubmitted = true
      this.isLoading = true
      return this.chatFollowService.getChat(chatId).then(response => {
        if (response.data.data !== null) {
          const { data } = response.data

          this.results = [{
            ...data,
            selected: false,
            error: '',
            issue_text_approved: false,
            chosen: {
              user_id: data.users.length ? data.users[0].id : '',
              tag: data.tags[0],
              campaign: this.getCampaign(data.tags[0], data.users[0] ?? null),
              isRecommendationReleased: false,
            },
          }]
          this.results.sort(this.dynamicSortMultiple(['chosen.campaign']))
        } else {
          this.toastDanger('Ops!', 'Nenhum resultado encontrado com os termos pesquisados')
        }
      }).catch(() => {
      }).finally(() => {
        this.isLoading = false
      })
    },

    getCampaign(tag, user) {
      if (!this.actionsList || this.actionsList.length === 0) {
        return ''
      }

      if (!this.actionsList[tag]) {
        return this.actionsList.descarte.default
      }

      if (!user || !user.status) {
        return this.actionsList[tag].default
      }

      if (this.actionsList[tag][user.status]) {
        if (typeof this.actionsList[tag][user.status] === 'object') {
          if (this.actionsList[tag][user.status][`${user.situation}.${user.plan_type}`]) {
            return this.actionsList[tag][user.status][`${user.situation}.${user.plan_type}`]
          }
          return this.actionsList[tag][user.status][`${user.situation}`]
        }

        return this.actionsList[tag][user.status]
      }

      return this.actionsList[tag].default
    },

    openAssignKanbanModal() {
      this.$refs['assign-kanban-modal'].show()
    },

    hideAssignKanbanModal() {
      this.$refs['assign-kanban-modal'].hide()
    },

    changePreventCloseModal(event) {
      this.preventCloseModal = event
    },

    handleProcessChosen() {
      const total = this.results.filter(f => f.selected).length
      this.$swal({
        title: `Processar os ${total} usuários selecionados?`,
        text: 'Esta ação não poderá ser desfeita!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, processar!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.postProcessChosen()
        }
      })
    },

    postProcessChosen() {
      const formData = new FormData()

      const data = {
        users: [],
      }

      this.isSubmitting = true
      data.users = this.results.filter(f => (f.selected))
      data.users = data.users.map(m => ({
        visitor_id: m.visitor_id,
        name: m.name,
        email: m.email,
        user_id: m.chosen.user_id,
        destination: m.chosen.campaign,
      }))
      formData.append('data', data)
      this.chatFollowService.postProcessChosen(data).then(response => {
        if (response.status === 200) {
          response.data.data.forEach(item => {
            if (item.success) {
              this.results = this.results.filter(f => f.visitor_id !== item.visitor_id)
            } else {
              const visitor = this.results.find(f => f.visitor_id === item.visitor_id)
              if (visitor) {
                visitor.error = item.message
              }
            }
          })
        }
      }).finally(() => {
        this.isSubmitting = false
      })
    },

    async handleAssignedUsers(data) {
      if (data) {
        for (let i = 0; i < this.dataAssignKanban.length; i += 1) {
          const returned = data.filter(f => (f.chat_id === this.dataAssignKanban[i].chat_id)).length > 0

          if (returned) {
            // eslint-disable-next-line no-await-in-loop
            await this.chatFollowService.setLeadProcessed(this.dataAssignKanban[i].chat_id)
          }
        }

        this.results = this.results.filter(f => data.filter(f2 => f2.id === f.chosen.user_id).length === 0)
      }
    },

    handleInvoiceDropDown(data) {
      this.isSubmitting = true

      IssueService.store({
        title: 'Nota Fiscal',
        content: 'Nota fiscal solicitada pelo chat',
        to_all_from: 'management_processes',
        user_id: data.chosen.user_id,
        status: 'open',
        tags: ['invoice'],
      }).then(data).then(() => {
        this.toastSuccess('Sucesso!', 'Ticket criado!')
      }).finally(() => {
        this.isSubmitting = false
      })
    },

    handleAssignKanbanDropDown(data, origin) {
      this.handleAssignKanban([{
        id: data.chosen.user_id,
        name: data.name,
        chat_id: data.visitor_id,
      }], origin)
    },

    handleAssignKanban(data, origin = 'all') {
      this.dataAssignKanban = data
      this.originAssignKanban = origin
      this.openAssignKanbanModal()
    },

    openMoveCard(data) {
      this.cardData = data
      this.$refs['move-card-modal'].show()
    },

    toggleAll(e) {
      this.results = this.results.map(m => ({
        ...m,
        selected: e,
      }))
    },
  },
}
</script>
<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';

  .no-padding {
    padding: 0px!important;
  }

  .id-select {
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .header-card{
    margin-bottom: 20px;
  }

  .form-buttons button{
    margin-right: 10px;
  }
</style>
